export const normalizeLoanRequirements = (rawSection = {}) => {
  const normalized = {
    why: {
      wide_choice: false,
      expert_advice: false,
      convienence: false,
      legwork: false,
      existing_customer: false,
      ...(rawSection.why || {}),
    },
    what_can_assist: {
      purchase: false,
      refinance: false,
      build_new_home: false,
      existing_loan: false,
      ...(rawSection.what_can_assist || {}),
    },
    property: rawSection.property || "",
    payment_plan: {
      repayment_prior_to_retirement: false,
      downsizing: false,
      sale_of_assets: false,
      super_income: false,
      super_lump_sum: false,
      savings: false,
      other_investments: false,
      co_app_income: false,
      other_check: false,
      other: "",
      ...(rawSection.payment_plan || {}),
    },
    loan_term: rawSection.loan_term || "",
    loan_term_other: rawSection.loan_term_other || "",
    changes_in_financial_circum: rawSection.changes_in_financial_circum || "",
    changes_in_financial_circum_yes: rawSection.changes_in_financial_circum_yes || "",
    loan_repayment_type: rawSection.loan_repayment_type || "",
    interest_only_term: rawSection.interest_only_term || "",
    rate_type: rawSection.rate_type || "",
    important_features: {
      basic_home_loan: {
        required: true,
        importance: "",
      },
      offset_account: {
        required: true,
        importance: "",
      },
      redraw_facility: {
        required: true,
        importance: "",
      },
      professional_packages: {
        required: true,
        importance: "",
      },
      extra_repayments_allowed: {
        required: true,
        importance: "",
      },
      ...(rawSection.important_features || {}),
    },
  };

  return normalized;
};

export const buildPersistedLoanRequirements = (normalizedSection) => {
  return { ...normalizedSection };
};
